import CalendarEnhancedV5 from '../calendar-enhanced-v5';
import { useRoute } from 'wouter';

export default function CalendarByIdPage() {
  // Get the propertyId from the URL using useRoute
  const [, params] = useRoute('/manager/calendar/:id');
  // Optionally, you could pass propertyId as a prop, but CalendarEnhancedV5 already reads from the URL
  // const propertyId = params?.id ? parseInt(params.id) : undefined;
  return <CalendarEnhancedV5 />;
} 